(function () {
  const badge = document.getElementById("shippingBadge");
  if (!badge) return;

  const cepInput = document.getElementById("shippingCep");
  const btn = document.getElementById("shippingCalcBtn");
  const etaEl = document.getElementById("shippingEta");
  const locEl = document.getElementById("shippingLocation");

  // TABELA EXEMPLO (ajuste com seu SLA real)
  // Regiões (bem comum em ecom BR)
  const ufToRegion = {
    // Norte
    AC:"Norte", AP:"Norte", AM:"Norte", PA:"Norte", RO:"Norte", RR:"Norte", TO:"Norte",
    // Nordeste
    AL:"Nordeste", BA:"Nordeste", CE:"Nordeste", MA:"Nordeste", PB:"Nordeste", PE:"Nordeste", PI:"Nordeste", RN:"Nordeste", SE:"Nordeste",
    // Centro-Oeste
    DF:"Centro-Oeste", GO:"Centro-Oeste", MT:"Centro-Oeste", MS:"Centro-Oeste",
    // Sudeste
    ES:"Sudeste", MG:"Sudeste", RJ:"Sudeste", SP:"Sudeste",
    // Sul
    PR:"Sul", RS:"Sul", SC:"Sul"
  };

  const regionToEta = {
    "Sudeste": "2 a 5 dias úteis",
    "Sul": "3 a 6 dias úteis",
    "Centro-Oeste": "4 a 7 dias úteis",
    "Nordeste": "8 a 10 dias úteis",
    "Norte": "6 a 12 dias úteis"
  };

  const ufToEta = {
  // Sudeste
  ES: "4 a 9 dias úteis",
  MG: "4 a 9 dias úteis",
  RJ: "4 a 9 dias úteis",
  SP: "3 a 8 dias úteis",

  // Sul
  PR: "3 a 8 dias úteis",
  SC: "4 a 9 dias úteis",
  RS: "4 a 9 dias úteis",

  // Centro-Oeste
  DF: "4 a 9 dias úteis",
  GO: "4 a 9 dias úteis",
  MT: "6 a 10 dias úteis",
  MS: "6 a 10 dias úteis",

  // Nordeste
  AL: "5 a 10 dias úteis",
  BA: "5 a 10 dias úteis",
  CE: "5 a 10 dias úteis",
  MA: "5 a 10 dias úteis",
  PB: "5 a 10 dias úteis",
  PE: "5 a 10 dias úteis",
  PI: "5 a 10 dias úteis",
  RN: "5 a 10 dias úteis",
  SE: "5 a 10 dias úteis",

  // Norte
  AC: "9 a 17 dias úteis",
  AP: "10 a 20 dias úteis",
  AM: "9 a 16 dias úteis",
  PA: "7 a 15 dias úteis",
  RO: "9 a 18 dias úteis",
  RR: "5 a 12 dias úteis",
  TO: "5 a 10 dias úteis"
};

  function formatCep(v) {
    const digits = (v || "").replace(/\D/g, "").slice(0, 8);
    if (digits.length <= 5) return digits;
    return digits.slice(0, 5) + "-" + digits.slice(5);
  }

  async function getAddressByCep(cep) {
    const clean = cep.replace(/\D/g, "");
    if (clean.length !== 8) throw new Error("CEP inválido");
    const r = await fetch(`https://viacep.com.br/ws/${clean}/json/`);
    const j = await r.json();
    if (j.erro) throw new Error("CEP não encontrado");
    return { city: j.localidade, uf: j.uf, bairro: j.bairro };
  }

  function calcEta(uf) {
  const region = ufToRegion[uf] || null;

  if (uf && ufToEta[uf]) {
    return { region, eta: ufToEta[uf] };
  }

  if (region && regionToEta[region]) {
    return { region, eta: regionToEta[region] };
  }

  return { region, eta: "4 a 9 dias úteis" };
}

  async function run() {
    try {
      btn.disabled = true;
      btn.textContent = "Calculando...";

      const cep = cepInput.value;
      const { city, uf } = await getAddressByCep(cep);
      const { region, eta } = calcEta(uf);

      etaEl.textContent = eta;
      locEl.innerHTML = `<small>para <u>${city}, ${uf}${region ? ` (${region})` : ""}</u></small>`;

      localStorage.setItem("ivora_last_cep", cep.replace(/\D/g, ""));
      badge.style.display = "flex";
    } catch (e) {
      alert(e.message || "Não foi possível calcular.");
    } finally {
      btn.disabled = false;
      btn.textContent = "Calcular";
    }
  }

  // UI
  cepInput.addEventListener("input", () => {
    cepInput.value = formatCep(cepInput.value);
  });
  btn.addEventListener("click", run);

  // Auto-carregar último CEP
  const last = localStorage.getItem("ivora_last_cep");
  if (last && last.length === 8) {
    cepInput.value = formatCep(last);
    badge.style.display = "flex";
    // opcional: auto-calcular
    // run();
  } else {
    badge.style.display = "flex";
  }
})();
